import styled from '@emotion/styled';

const Button = styled.button<{ noMargin?: boolean }>`
  box-sizing: border-box;
  width: fit-content;
  height: 48px;

  border: none;
  background: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 8px;

  padding: 0;

  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '32px')};
`;

const S = { Button };

export default S;
